import { useQuery } from 'react-query';

import { useCatalogProductIdParams } from '../hooks/useCatalogProductIdParams';
import { getMaximumBenefitParam, maximumBenefitQueryOption } from '../repositories/maximumBenefitQuery';
import { usePdpBaseInfo } from './usePdpBaseInfo';

export const useMaximumBenefit = () => {
  const params = useCatalogProductIdParams();
  const catalog_product_id = params.catalog_product_id;
  const {
    product: { product_price, trait_list },
    shop,
  } = usePdpBaseInfo({ catalog_product_id });
  const param = getMaximumBenefitParam({
    productId: catalog_product_id,
    productPrice: product_price,
    shopId: shop.id,
    traitList: trait_list,
  });
  const { data, ...response } = useQuery(maximumBenefitQueryOption(param));

  const payment_event_list_for_display = data?.payment_event_list_for_display.item_list ?? [];

  payment_event_list_for_display.sort((a, b) => {
    if (a.payment_method === 'KAKAOPAY' && b.payment_method !== 'KAKAOPAY') return -1;
    if (a.payment_method !== 'KAKAOPAY' && b.payment_method === 'KAKAOPAY') return 1;

    if (a.priority < b.priority) return -1;
    if (a.priority > b.priority) return 1;

    return Number(b.date_created) - Number(a.date_created);
  });

  return {
    payment_event_list_for_display: data?.payment_event_list_for_display.item_list ?? [],
    payment_notification_list: data?.payment_notification_list.item_list ?? [],
    product_option_list: data?.pdp_option_info?.catalog_product.product_option_list ?? [],
    pdp_max_coupon_discount: data?.pdp_user_base_info?.pdp_max_coupon_discount ?? {
      discount_amount: 0,
      discount_type: '',
      user_account_coupon_policy_id: '',
      issue_status: '',
      title: '',
      registration_type: null,
    },
    pdp_duplication_coupon_discount: data?.pdp_user_base_info?.pdp_duplication_coupon_discount ?? {
      discount_amount: 0,
      discount_type: '',
      user_account_coupon_policy_id: '',
      issue_status: '',
      title: '',
      registration_type: null,
      badge: null,
    },
    pdp_user_account_mileage: data?.pdp_user_base_info?.pdp_user_account_mileage,
    pdp_user_base_info: data?.pdp_user_base_info,
    ...response,
  };
};
